import { ca } from '@cian/analytics';
import { EServiceId } from '../../types/reducers/publishTerms';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../types/analytics';

interface ITrackPublicationWrapperShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  isPackagesAvailable: boolean;
  isPackagesVisible: boolean;
  activePackageServiceId: EServiceId | null;
}

export const trackPublicationWrapperShow = (params: ITrackPublicationWrapperShowParams) => {
  const { analyticsOfferStatus, analyticsProduct, isPackagesAvailable, isPackagesVisible, activePackageServiceId } =
    params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: 'publication',
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest_webview',
        pack_available: Number(isPackagesAvailable),
        pack_chosen: Number(isPackagesVisible),
        ...(activePackageServiceId && { publication_type: activePackageServiceId }),
      },
    },
  });
};
